export const TEMPLATE_VARIABLE_REGEX = /\{\{\{([^}]+)\}\}\}/g;

export const TEMPLATE_VARIABLE_CHIP_CLASS = 'template-variable-chip';

export function createVariableChip(token: string): HTMLSpanElement {
  const chip = document.createElement('span');
  chip.className = TEMPLATE_VARIABLE_CHIP_CLASS;
  chip.setAttribute('contenteditable', 'false');
  chip.setAttribute('data-template-var', token);
  chip.setAttribute('data-tooltip', token);
  chip.setAttribute('title', token);
  chip.setAttribute('aria-label', token);
  return chip;
}

export function appendRawTextWithChips(target: HTMLElement | DocumentFragment, rawText: string): void {
  TEMPLATE_VARIABLE_REGEX.lastIndex = 0;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = TEMPLATE_VARIABLE_REGEX.exec(rawText)) !== null) {
    if (match.index > lastIndex) {
      target.appendChild(document.createTextNode(rawText.slice(lastIndex, match.index)));
    }
    target.appendChild(createVariableChip(match[0]));
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < rawText.length) {
    target.appendChild(document.createTextNode(rawText.slice(lastIndex)));
  }
}

export function serializeVariableChips(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>(`.${TEMPLATE_VARIABLE_CHIP_CLASS}`).forEach((chip) => {
    const token = chip.getAttribute('data-template-var') || '';
    chip.replaceWith(document.createTextNode(token));
  });
}

export function getSerializedInnerHtml(root: HTMLElement): string {
  const clone = root.cloneNode(true) as HTMLElement;
  serializeVariableChips(clone);
  return clone.innerHTML;
}

export function getElementRawText(el: HTMLElement): string {
  const clone = el.cloneNode(true) as HTMLElement;
  serializeVariableChips(clone);
  return (clone.textContent || '').trim();
}

export function setElementContent(el: HTMLElement, rawText: string): void {
  const trimmed = (rawText || '').trim();
  if (!trimmed) {
    el.innerHTML = '&nbsp;';
    return;
  }

  el.textContent = '';
  appendRawTextWithChips(el, rawText);
}

export function applyVariableChipsToRoot(root: HTMLElement): void {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  let node = walker.nextNode();
  while (node) {
    const textNode = node as Text;
    const parent = textNode.parentElement;
    if (parent && !parent.closest(`.${TEMPLATE_VARIABLE_CHIP_CLASS}`) && textNode.textContent?.includes('{{{')) {
      textNodes.push(textNode);
    }
    node = walker.nextNode();
  }

  for (const textNode of textNodes) {
    const text = textNode.textContent || '';
    TEMPLATE_VARIABLE_REGEX.lastIndex = 0;
    if (!TEMPLATE_VARIABLE_REGEX.test(text)) {
      continue;
    }

    TEMPLATE_VARIABLE_REGEX.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    appendRawTextWithChips(fragment, text);
    textNode.parentNode?.replaceChild(fragment, textNode);
  }
}
